<template>
    <!-- 导出 -->
    <el-dialog :title="title" width="30%" :visible="isShow" @close="$emit('hide')">
        <el-form ref="form" :model="values" :rules="rules" v-loading="loading">
            
            <el-form-item v-for="(item, index) in checkMapList" :key="index">
                <label>{{item.name}}：</label>
                <el-checkbox-group v-model="item.values">
                    <el-checkbox
                        v-for="(box, boxIndex) in item.list"
                        :key="boxIndex"
                        :label="boxIndex">{{ box.fieldName }}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button :loading="isSubmitting" type="primary" @click="onSubmit">{{ submitName }}</el-button>
                <el-button @click.stop="$emit('hide')">取消</el-button>
            </span>
    </el-dialog>
</template>

<script>
import api from '@/api/index.js'
import down from '@/mixins/down.js'

export default {
    name: 'ExprotFolderDialog',
    mixins: [down],
    props: {
        folderId: {
            type: [Number, String],
            default: 0
        },
        title: {
            type: String,
            default: '导出'
        },
        isShow: {
            type: Boolean,
            default: false
        },
        exprotName: {
            type: String,
            default: '祈源文化后台系统资料'
        }
    },
    data () {
        return {
            loading: false,
            values: {},
            rules: {},
            isSubmitting: false,
            checkList: [],
            checkMapList: []
        }
    },
    watch: {
        isShow (value) {
            if (value) {
                this.checkMapList = [
                    {
                    name: '老师',
                    values: [],
                    list: []
                    },
                    {
                        name: '学生',
                        values: [],
                        list: []
                    }
                ]
                this.getSchemeList()
            }
        }
    },
    computed: {
        submitName () {
            return this.isSubmitting ? '导出中' : '导出'
        },
        isRootDir () {
            return this.folderId === 0 || this.folderId === '0'
        }
    },
    mounted () {
    },
    methods: {
        // 导出
        async onSubmit () {
            try {
                const folderId = this.folderId
                // fieldName rank
                const fields_1 = this.checkMapList[0].values.map(m => {
                    return {
                        fieldName: this.checkMapList[0].list[m].fieldName,
                        rank: this.checkMapList[0].list[m].rank
                    }
                })
                const fields_2 = this.checkMapList[1].values.map(m => {
                    return {
                        fieldName: this.checkMapList[1].list[m].fieldName,
                        rank: this.checkMapList[1].list[m].rank
                    }
                })
                const params = {
                    folderId: folderId,
                    folderName: {'1':'老师','2':'学生'},
                    folderField: {
                        '1': fields_1,
                        '2': fields_2
                    }
                }
                await this.__pushToDownList(folderId)
                const resp = await api.downlowndFolderField(params, (pro) => {
                    this.__updateDownProgressData(folderId, pro)
                })
                console.log(resp, 'resprespresp')
                this.__completeDownload(folderId, resp, this.exprotName)
            } catch (error) {
                console.log(error)
                this.$message.error(error.message)
            }
        },
        // 获取公共字段列表
        async getSchemeList () {
            try {
                let params = {
                    folderId: this.folderId
                }
                if (this.isRootDir) {
                    params = {
                        defaultField: 1
                    }
                }
                const resp = await api.loadScheme(params)
                if (resp.success) {
                    const map = {}
                    resp.data.list.forEach((item, index) => {
                        if (item.fieldKey !== 'picture') {
                            if (item.userType === 1) {
                                this.checkMapList[0].list.push(item)
                            } else if (item.userType === 2) {
                                this.checkMapList[1].list.push(item)
                            }
                        }
                    })
                    this.selectAll()
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(error.message)
            }
        },
        selectAll () {
            this.checkMapList.forEach(item => {
                const len = item.list.length
                item.values = new Array(len).fill(0).map((m, i) => i)
            })
        }
    }
}
</script>

<style>

</style>